const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 0c2.771 0 5.368.719 7.64 1.96L25.158.442c1.067-1.067 1.6 0 1.6 1.066v2.134L22.4 8V4.916A12.734 12.734 0 0016 3.2C8.931 3.2 3.2 8.93 3.2 16c0 7.069 5.731 12.8 12.8 12.8S28.8 23.069 28.8 16c0-2.332-.626-4.517-1.716-6.4H24l3.783-3.783.299-.3.276-.275h2.134c1.066 0 2.133.534 1.066 1.6L30.04 8.36A15.882 15.882 0 0132 16c0 8.837-7.164 16-16 16S0 24.837 0 16C0 7.164 7.164 0 16 0zm0 5.867c2.39 0 4.583.833 6.316 2.217l-2.283 2.284A6.898 6.898 0 0016 9.067 6.933 6.933 0 1022.933 16a6.888 6.888 0 00-1.301-4.032l2.284-2.284A10.086 10.086 0 0126.133 16c0 5.596-4.536 10.134-10.133 10.134S5.867 21.596 5.867 16 10.403 5.867 16 5.867zm0 5.866c.767 0 1.485.205 2.107.56l-3.174 3.174c-1.067 1.066.533 2.667 1.6 1.6l3.174-3.175A4.266 4.266 0 1116 11.733z"
});

const SvgObjectives = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#18bde6",
    fillRule: "evenodd",
    height: 32,
    width: 32,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgObjectives, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/objectives.dba3259f.svg";
export { ForwardRef as ReactComponent };